import styled from '@emotion/styled';
import { Delete as DeleteIcon } from '@material-ui/icons';

const StyledDeleteIcon = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.danger
}));

export default StyledDeleteIcon;
